
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { VIcon, VSnackbar } from 'vuetify/lib';

Vue.use(Vuetify, {
    components: {
        // the components which Toast.vue used
        VIcon,
        VSnackbar
    }
});

export default new Vuetify({
    theme: {
        dark: true,
        icons: {
            iconfont: 'fa', // default - only for display purposes
        },
        themes: {
            dark: {
                primary: '#c2185b',
                secondary: '#fbb5b5',
                accent: '#c2fdc2',
                error: '#f74242',
                info: '#fff',
                success: '#3caf3c',
                warning: '#bcbf3b',
            },
        },
    },
});
